import { DraftDataDto, FormSectionDto } from "@green0meter/api-client";
import { pdf } from "@react-pdf/renderer";

import { AssetQuestion } from "../../Questionnaires.types";

export const generatePdfAssetQuestions = (
  formSections: FormSectionDto[],
  draftData: DraftDataDto[],
): { questions: AssetQuestion[]; relevantYear: string } => {
  const relevantYearQuestion = formSections
    .flatMap((section) => section.formQuestions || [])
    .find((q) => q.code === "relevant-year");

  const relevantYear =
    draftData.find((data) => data.id === relevantYearQuestion?.questionId)?.value ??
    "";

  const questions: AssetQuestion[] = formSections.flatMap((section) =>
    (section.formQuestions || []).map((q) => {
      const draftDataValue =
        draftData.find((data) => data.questionCode === q.code)?.value ?? "";

      const answer = q?.answerOptions
        ? q.answerOptions
            .find((option) => option.id === draftDataValue)
            ?.name.toString() || ""
        : (draftDataValue as string);

      return {
        number: q.code,
        text: q.name,
        answer: answer || "",
        relevantYear: relevantYear as string,
        comment: "",
      };
    }),
  );

  return { questions, relevantYear: relevantYear as string };
};

export const downloadPdfBlob = async ({
  fileName,
  pdfDocument,
}: {
  fileName: string;
  pdfDocument: JSX.Element;
}): Promise<void> => {
  const blob = await pdf(pdfDocument).toBlob();
  const downloadLink = document.createElement("a");

  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = fileName;
  downloadLink.click();
  URL.revokeObjectURL(downloadLink.href);
};
